export const AppConfig = {
    API_BASE_URL: "https://pag-api-dev.4seeanalytics.com/api/"
};

export default AppConfig;
